<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="管理员名称" prop="word">
				<el-input v-model="query.word" placeholder="请输入管理员名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增管理员
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column type="index" align="center" />
			<el-table-column label="账号" align="center" prop="account" />
			<el-table-column label="姓名" align="center" prop="name" />
			<el-table-column label="手机号" align="center" prop="phone" />
			<el-table-column label="创建时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center" prop="status">
				<template slot-scope="{ row }">
					<el-tag :type="row.status == 1 ? 'success' : 'danger'">
						{{ ['禁用', '启用'][row.status] }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="{ row }">
					<el-link style="margin-right: 10px" :underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link :underline="false" type="danger" @click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, del } from "@/api/permission/admin";
import listMixin from '@/mixins/list';

export default {
	data() {
		return {
			// 查询参数
			query: {
				word: "",
			},
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/permission/admin/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/admin/form", query: { id: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该管理员?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>